import React from 'react';
import './StandardButton.scoped.scss';

class ComponentProps {
    buttonText: string = "";
    buttonIconURL?: string | undefined = undefined;
    buttonIconWidth?: number | undefined = undefined;
    buttonIconBeforeURL?: string | undefined = undefined;
    buttonTheme?: StandardButtonTheme;
    isIntroButton?: boolean;
    buttonClickCallback: (() => void) | undefined;
}

export enum StandardButtonTheme {
    blueBackground = "blueBackground",
    whiteBackground = "whiteBackground",
    whiteBackgroundBlueBorder = "whiteBackgroundBlueBorder"
}

class StandardButton extends React.Component<ComponentProps, any> {
    render() {
        let iconElement = <></>
        let buttonTheme = this.props.buttonTheme ?? StandardButtonTheme.blueBackground;
        if (this.props.buttonIconURL && this.props.buttonIconURL.length > 0) {
            const imageStyle = {
                width: this.props.buttonIconWidth + 'px'
            }
            iconElement = <img className="button-icon" src={this.props.buttonIconURL} style={imageStyle} alt="Button Icon"></img>
        }
        let iconElementBefore = <></>
        if (this.props.buttonIconBeforeURL && this.props.buttonIconBeforeURL.length > 0) {
            const buttonStyle = {
                width: this.props.buttonIconWidth + 'px'
            }
            iconElementBefore = <img className="button-icon before" src={this.props.buttonIconBeforeURL} style={buttonStyle} alt="Button Icon"></img>
        }
        return (
            <div className={['standard-button', buttonTheme, (this.props.isIntroButton ? 'introButton' : '')].join(' ')} onClick={this.props.buttonClickCallback}>
                <div className="standard-button-inner">
                    {iconElementBefore}
                    <div className="button-text">{this.props.buttonText}</div>
                    {iconElement}
                </div>
            </div>
        )
    }
}

export default StandardButton;

